import React, { type ReactElement } from 'react';
import Alert from 'atom-components/alert';
import { joinWithConjunction, pluralise } from 'helpers/string.helpers';

export type NoResultsAlertProps = {
  entity: string | string[]; // The entity(s) that there are no results for.
  hideSuggestion?: boolean; // Hide the default "refine search" suggestion.
};

/**
 * Displays a consistent 'No Results Found' message that can be used when
 * displaying datasets with zero results throughout Assist.
 */
export default function NoResultsAlert({
  entity,
  hideSuggestion
}: NoResultsAlertProps): ReactElement {
  function displayEntities(): string {
    if (Array.isArray(entity)) {
      return joinWithConjunction(
        entity.map((e) => pluralise(e, 0)),
        'or'
      );
    }
    return pluralise(entity, 0);
  }

  return (
    <Alert variant="info">
      No {displayEntities()} were found.
      {hideSuggestion ? '' : ' You may need to broaden your search criteria.'}
    </Alert>
  );
}
